<template>
  <span v-if="!mobileView" class="ds-dt-wrap">
    <slot></slot>
  </span>
  <span v-else class="ds-dt-wrap-mob">
    <slot name="mob"></slot>
  </span>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "DtWrap",

  data() {
    return {
      properties: []
    };
  },
  computed: {
    mobileView: function () {
      return window.$docsify && window.$docsify.mobileOnly
        ? window.$docsify.mobileOnly
        : false;
    }
  }
});
</script>
